import { CollapsibleSection } from "components/designV2/collapsibleSection/collapsibleSection";
import { useTranslation } from "react-i18next";
import { type CompanyGigApplications } from "model/Gig";
import type { PendingApplicationAction } from "./teamPublicDetailsModal.contract";
import { TeamPublicDetailsModalApplicationRow } from "./teamPublicDetailsModal.applicationRow.component";
import {
  ApplicationsCountBadge,
  ApplicationsList,
} from "./teamPublicDetailsModal.styled";
import { DetailsMessage } from "../shiftDetailsModal.styled";

interface TeamPublicDetailsModalApplicationsSectionProps {
  pendingApplications: ReadonlyArray<CompanyGigApplications>;
  activeApplicationId: number | null;
  avatarUrls: Record<string, string>;
  onOpenMotivationalLetterModal: (motivationalLetter: string) => void;
  onOpenApplicationActionConfirm: (
    applicationId: number,
    status: PendingApplicationAction["status"],
    applicantName: string,
  ) => void;
}

export const TeamPublicDetailsModalApplicationsSection: React.FC<
  TeamPublicDetailsModalApplicationsSectionProps
> = (props) => {
  const { t } = useTranslation();
  const hasPendingApplications = props.pendingApplications.length > 0;

  return (
    <CollapsibleSection
      label={t("Schedule.TeamPublicApplications")}
      defaultOpen={hasPendingApplications}
      headerLeft={
        hasPendingApplications ? (
          <ApplicationsCountBadge>
            {props.pendingApplications.length}
          </ApplicationsCountBadge>
        ) : undefined
      }
    >
      {!hasPendingApplications ? (
        <DetailsMessage>
          {t("ApplicationsCompany.NoApplications")}
        </DetailsMessage>
      ) : (
        <ApplicationsList>
          {props.pendingApplications.map((application) => (
            <TeamPublicDetailsModalApplicationRow
              key={application.id}
              application={application}
              avatarUrl={props.avatarUrls[application.worker.externalId]}
              isBusy={props.activeApplicationId === application.id}
              canManageApplication
              onOpenMotivationalLetterModal={
                props.onOpenMotivationalLetterModal
              }
              onOpenApplicationActionConfirm={
                props.onOpenApplicationActionConfirm
              }
            />
          ))}
        </ApplicationsList>
      )}
    </CollapsibleSection>
  );
};
